import React, { useEffect } from "react";
import { useState } from "react";
import { useLogin, useNotify, Notification } from "react-admin";
import PublicProvider from "../../Providers/PublicProvider";
import { Container, LoginContainer } from "./styles";
import TextField from "@material-ui/core/TextField";
import { ReactComponent as Logo } from "../../Assets/images/logo.svg";
import Button from "@material-ui/core/Button";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import queryString from "query-string";

function Login({ location }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [notFound, setNotFound] = useState(false);
  const login = useLogin();
  const notify = useNotify();

  const submit = (e) => {
    e.preventDefault();
    //console.log(email, password);
    login({ username: email, password }).catch(() =>
      notify("Usuário ou senha inválidos.")
    );
  };

  useEffect(() => {
    const params = queryString.parse(location.search);
    if (params.verificationCode) {
      //alert("abrir treta");
      verifyCode(params.verificationCode);
    }
    //var query = getQueryParams(document.location.verificationCode);
    const loadData = async () => {
      const { data } = await PublicProvider().getStore();
      if (!data) {
        setNotFound(true);
      }
    };
    loadData();
  }, []);

  const forgetPassword = async (e) => {
    e.preventDefault();

    const result = await Swal.mixin({
      input: "text",
      confirmButtonText: "Recuperar",
      showCancelButton: true,
      reverseButtons: true,
    }).queue([
      {
        title: "Recuperar senha",
        input: "email",
        customClass: {
          input: "data-hj-allow",
        },
        validationMessage: "Informe um email válido",
        text: "Digite o email cadastrado",
      },
    ]);

    if (result.value) {
      const [email] = result.value;

      const response = await PublicProvider()
        .sendVerificationToken({
          email,
        })
        .then((data) => {
          ////console.log(data, Object.keys(data));
          Swal.fire({
            title: "Confira seu email",
            text:
              "Enviamos um email com informações para recuperação da sua senha.",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Ok, vamos lá!",
          });
        })
        .catch((error) => {
          //console.log(error, Object.keys(error));
          Swal.fire({
            position: "top-end",
            title: "Atenção!",
            text: "Verifique o email informado e tente novamente.",
            icon: "error",
            confirmButtonText: "Ok",
          });
        });
    }
  };

  function verifyCode(code) {
    Swal.mixin({
      input: "text",
      confirmButtonText: "Alterar",
      showCancelButton: false,
      reverseButtons: true,
    })
      .queue([
        {
          inputValidator: (value) => {
            return new Promise((resolve) => {
              //console.log(value);
              if (
                document.getElementById("swal-input1").value ===
                document.getElementById("swal-input2").value
              ) {
                resolve();
              } else {
                resolve("As senhas não conferem");
              }
            });
          },
          preConfirm: () => {
            return document.getElementById("swal-input1").value;
          },
          title: "Agora falta pouco!",
          input: "multiple",
          html:
            '<div id="swal2-content" class="swal2-html-container" >Defina uma nova senha e abaixo confirme</div>' +
            '<input id="swal-input1" type="password" class="swal2-input" placeholder="Digite a senha">' +
            '<input id="swal-input2" type="password" class="swal2-input" placeholder="Confirme a senha">',
        },
      ])
      .then((result) => {
        const password = result.value[0];
        const confirmPassword = result.value[1];

        PublicProvider()
          .forgetPassword({
            verificationCode: code,
            password: password,
            confirmPassword: password,
          })
          .then((data) => {
            ////console.log(data);
            Swal.fire({
              title: "Senha alterada com sucesso!",
              text: "Você já pode logar com a sua nova senha",
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Ok, vamos lá!",
            });
          })
          .catch((error) => {
            //console.log(error);
            Swal.fire({
              position: "top-end",
              title: "Atenção!",
              text:
                "Ocorreu um erro ao cadastrar sua nova senha. Tente novamente mais tarde.",
              icon: "error",
              confirmButtonText: "Ok",
            });
          });
      });
  }

  return (
    <Container>
      <LoginContainer onSubmit={submit}>
        <Logo className="logoMenuLegal" />
        {notFound ? (
          <>
            <h3>Não encontrado</h3>
            <p>Verifique o endereço informado e tente novamente.</p>
          </>
        ) : (
          <>
            <TextField
              style={{ marginBottom: 10, marginTop: 15 }}
              autoFocus
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              style={{ marginBottom: 20 }}
              label="Senha"
              type={"password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <a
              className="forgetPasswordLink"
              href="#"
              onClick={(e) => forgetPassword(e)}
            >
              Esqueceu a senha?
            </a>
            <Button type="submit" value="Enviar">
              Enviar
            </Button>
          </>
        )}
      </LoginContainer>
      <Notification />
    </Container>
  );
}

export default Login;
